module.exports = require("../../../../node_modules/@marko/compiler/dist/taglib");
